import * as request from '@/utils/requestTog'

export default {
  // 开户申请记录
  getAccountRecordList(data) {
    return request.post('/v1/manage/apply/log/index', data)
  },

  // 开户申请记录审核
  applyAccountRecord(id, data) {
    return request.post(`/v1/manage/apply/log/examine/${id}`, data)
  },

  // 行业分类列表
  getIndustryTypeList(data) {
    return request.get('/v1/temp/type/list', data)
  },

  // 公司保单列表
  getAllInsOrder(data) {
    return request.post('/insure/allinsorder', data)
  },

  // 保单列表
  getInsList(data) {
    return request.post('/insure/getAllInsList', data)
  },

  // 获取商户列表
  getBusinessList(data) {
    return request.post('/insure/getMerchantList', data)
  },

  // 审核客户开通服务
  examineMerchant(data) {
    return request.post('/insure/auditMerchant', data)
  },

  // 获取考勤列表
  getAllClockLinkList(data) {
    return request.post('/insure/getAllClockLinkList', data)
  },

  // 公告列表
  getHrAnnounceList(data) {
    return request.get('/v1/manage/common/announcement', data)
  },

  // 创建公告
  createHrAnnounce(data) {
    return request.post('/v1/manage/common/announcement/create', data)
  },

  // 修改公告
  editHrAnnounce(id, data) {
    return request.put(`/v1/manage/common/announcement/${id}`, data)
  },

  // 修改公告状态
  updateHrAnnounceStatus(id, data) {
    return request.put(`/v1/manage/common/announcement/setStatus/${id}`, data)
  },

  // 删除公告
  deleteHrAnnounce(id) {
    return request.deleteById(`/v1/manage/common/announcement/${id}`)
  },

  // 公告详情
  getHrAnnounceInfo(id) {
    return request.get(`/v1/manage/common/announcement/${id}`)
  },

  // 资讯列表
  getInformationList(data) {
    return request.get('/v1/manage/info/index', data)
  },

  // 创建资讯
  createInformation(data) {
    return request.post('/v1/manage/info/store', data)
  },

  // 修改资讯
  editInformation(id, data) {
    return request.put(`/v1/manage/info/update/${id}`, data)
  },

  // 资讯详情
  getInformationInfo(id) {
    return request.get(`/v1/manage/info/view/${id}`)
  },

  // 删除资讯
  deleteInformation(id) {
    return request.deleteById(`/v1/manage/info/del/${id}`)
  },

  // 资讯审核列表
  getInformationReviewList(data) {
    return request.get('/v1/opcpark/pc/information/index', data)
  },

  // 资讯审核详情
  getInformationReviewDetail(id) {
    return request.get(`/v1/opcpark/pc/information/info/${id}`)
  },

  // 编辑资讯审核
  updateInformationReview(id, data) {
    return request.put(`/v1/opcpark/pc/information/update/${id}`, data)
  },

  // 审核资讯
  auditInformationReview(id, data) {
    return request.post(`/v1/opcpark/pc/information/audit/${id}`, data)
  },

  // 资讯驳回意见
  getInformationRejectReason(id) {
    return request.get(`/v1/opcpark/pc/information/reject_reason/${id}`)
  },

  // 获取同步位置
  getInformationPublishList(data) {
    return request.get('/v1/manage/info/publish_list', data)
  },

  getPublishTypeList(data) {
    return request.post('/v1/hr/policy/publish_policy_channel', data)
  },

  // 同步数据
  publishSyncSet(data) {
    return request.post('/v1/manage/info/sync', data)
  },

  // 获取高校小程序发布位置
  getMiniappPublishPos(data) {
    return request.post('/v1/hr/policy/publish_channel', data)
  },

  // 课程列表
  getCourseList(data) {
    return request.post('/v1/train/admin/train/index', data)
  },

  // 课程审核列表
  getCourseReviewList(data) {
    return request.post('/v1/opcpark/pc/course/index', data)
  },

  // 课程审核详情
  getCourseReviewDetail(id) {
    return request.get(`/v1/opcpark/pc/course/info/${id}`)
  },

  // 课程审核
  examineCourseReview(id, data) {
    return request.post(`/v1/opcpark/pc/course/audit/${id}`, data)
  },

  // 课程驳回意见
  getCourseRejectReason(id) {
    return request.get(`/v1/opcpark/pc/course/reject_reason/${id}`)
  },

  // 课程下拉枚举
  getCourseReviewOptions(data) {
    return request.get('/v1/opcpark/pc/course/options', data)
  },

  // 课程创建
  courseCreate(data) {
    return request.post('/v1/train/admin/train/create', data)
  },

  // 批量创建课程
  batchCourseCreate(data) {
    return request.post('/v1/manage/train/store', data)
  },

  // 课程报名记录
  getCourseRegistrationList(data) {
    return request.get('/v1/train/admin/train/join/log/index', data)
  },

  // 课程详情
  getCourseDetail(id) {
    return request.get(`/v1/train/admin/train/info/${id}`)
  },

  // 课程修改
  updateCourse(id, data) {
    return request.put(`/v1/train/admin/train/update/${id}`, data)
  },

  // 课程上下架
  courseOnOff(id, data) {
    return request.post(`/v1/train/admin/train/up_or_down/${id}`, data)
  },

  // 行业列表
  getCourseIndustryList(data) {
    return request.get('/v1/task/type/list', data)
  },

  // 获取课程发布过后的位置
  getCoursePosition(data) {
    return request.get('/v1/manage/train/publish_list', data)
  },

  // 同步数据课程
  syncCourse(data) {
    return request.post('/v1/manage/train/sync', data)
  },

  // 获取课程发布位置
  getCoursePublishPos(data) {
    return request.post('/v1/hr/train/publish_channel', data)
  },

  // 获取小程序发布位置
  getSchoolMiniappList(data) {
    return request.post('/v1/projecthr/schoolRecruitList', data)
  },

  // 获取城市列表
  getCourseAreaList(data) {
    return request.get('/v1/area/list', data)
  },

  // 获取项目文档列表
  getDocList(data) {
    return request.get('/v1/manage/employment/project/doc/list', data)
  },

  // 获取项目列表
  getProjectList(data) {
    return request.get('/v1/manage/employment/project/list', data)
  },

  // 项目详情
  getProjectDetails(id) {
    return request.get(`/v1/manage/employment/project/view/${id}`)
  },

  // 项目审核
  examineProject(id, data) {
    return request.put(`/v1/manage/employment/project/examine/${id}`, data)
  },

  // 项目类型列表
  projectTypeList(data) {
    return request.get('/v1/manage/employment/project/type/list', data)
  },

  // 岗位列表
  getRecruitTaskList(data) {
    return request.get('/v1/manage/recruit/task/index', data)
  },

  // 岗位人员列表
  getRecruitTaskEmployeeList(data) {
    return request.get('/v1/manage/recruit/task/employee/list', data)
  },

  // 负责人列表
  getProjectLeaderList(data) {
    return request.get('/v1/hr/employee/getlist', data)
  },

  // 岗位人员审核
  examineRecruitPersonStatus(data) {
    return request.post('/v1/manage/recruit/task/employee/examine', data)
  },

  // 岗位上下架
  updateRecruitTaskStatus(id, data) {
    return request.post(`/v1/manage/recruit/task/status/${id}`, data)
  },

  // 岗位详情
  getRecruitTaskInfo(id) {
    return request.get(`/v1/manage/recruit/task/view/${id}`)
  },

  // 岗位审核
  examineRecruitTaskStatus(id, data) {
    return request.post(`/v1/manage/recruit/task/examine_status/${id}`, data)
  },

  // 获取高校列表
  getSchoolListApi(data) {
    return request.get('/v1/school/demand/school_list', data)
  },

  // 修改甲乙帮帮项目
  putProjectUpdate(id, data) {
    return request.put(`/v1/enterprise/project/update/${id}`, data)
  },

  // 项目详情中人员列表
  getEnterpriseEmployeeList(data) {
    return request.get('/v1/enterprise/employee/index', data)
  },

  // 项目详情中人员签约发起
  getEnterpriseEmployeeSignLaunch(data) {
    return request.post('/v1/enterprise/employee/sign/launch', data)
  },

  // 添加岗位
  getRecruitTaskStore(data) {
    return request.post('/v1/hr/recruit/task/store', data)
  },

  // 编辑岗位
  postRecruitTaskStore(id, data) {
    return request.put(`/v1/hr/recruit/task/update/${id}`, data)
  },

  // 岗位标签列表
  getRecruitLabelList(data) {
    return request.get('/v1/hr/recruit/label/list', data)
  },

  // 普通岗位行业列表
  getRecruitIndustryList(data) {
    return request.get('/v1/manage/employment/project/type/list', data)
  },

  // 项目/岗位详情页
  getHrProjectDetail(id) {
    return request.get(`/v1/manage/employment/project/view/${id}`)
  },

  // 岗位同步特定小程序
  synchronizationMinapp(data) {
    return request.post('/v1/hr/recruit/task/up', data)
  }
}
